module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/day02_01_stay-8ddcb177a74915de71dc45d32edcbbf0.jpg";